import { c as _c } from "react/compiler-runtime";
import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';
export type BadgeProps = HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badge>;
const Badge = t0 => {
  const $ = _c(12);
  let children;
  let className;
  let props;
  let variant;
  if ($[0] !== t0) {
    ({
      children,
      className,
      variant,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = variant;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    variant = $[4];
  }
  let t1;
  if ($[5] !== className || $[6] !== variant) {
    t1 = badge({
      variant,
      className
    });
    $[5] = className;
    $[6] = variant;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== children || $[9] !== props || $[10] !== t1) {
    t2 = <span className={t1} {...props}>{children}</span>;
    $[8] = children;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
const badge = cva(['inline-flex items-center justify-center text-caption-1 rounded-lg px-2 py-1 text-nowrap h-fit'], {
  variants: {
    variant: {
      accent: ['text-quinary', 'bg-accent'],
      error: ['text-error', 'bg-error'],
      info: ['text-info', 'bg-info'],
      neutral: ['text-neutral', 'bg-neutral'],
      success: ['text-success', 'bg-success'],
      warning: ['text-warning', 'bg-warning'],
      successInverted: ['text-successInverted', 'bg-successInverted'],
      warningInverted: ['text-warningInverted', 'bg-warningInverted'],
      errorInverted: ['text-errorInverted', 'bg-errorInverted'],
      infoInverted: ['text-infoInverted', 'bg-infoInverted'],
      neutralInverted: ['text-neutralInverted', 'bg-neutralInverted']
    }
  },
  defaultVariants: {
    variant: 'neutral'
  }
});
export default Badge;